import Annotation from "./annotation";
import { SliceLayerTypes } from "../../config/config";
import { setLineStyle } from "../canvasUtils";

export default class Segmentation extends Annotation {
  constructor() {
    super();

    this.ilm = [];
    this.rpe = [];
    this.lineWidth = 3;
    this.ilmColor = "red";
    this.rpeColor = "magenta";
    this.sliceInfo = null;
    this.stretchSegmentation = false;

    this.xScale = 1;
    this.yScale = 1;
    this.isFlipped270 = false;
  }

  draw(ctx) {
    if (!this.sliceInfo || !this.ilm.length || !this.rpe.length) return;

    if (this.stretchSegmentation) this.calculateStretch(ctx);


    setLineStyle(ctx, this);
    ctx.strokeStyle = this.ilmColor;
    this.drawPath(ctx, this.ilm);
    ctx.strokeStyle = this.rpeColor;
    this.drawPath(ctx, this.rpe);
  }

  calculateStretch(ctx) {
    let dim = this.sliceInfo.dimensions;
    let scale = window.devicePixelRatio || 1;
    let size = ctx.canvas;
    if (this.isFlipped270) {
      this.xScale = size.height / (dim.pixelWidth * scale);
      this.yScale = size.width / (dim.pixelHeight * scale);  
    }
    else {
      this.xScale = size.width / (dim.pixelWidth * scale);
      this.yScale = size.height / (dim.pixelHeight * scale);
    }
  }

  drawPath(ctx, data) {
    ctx.beginPath();
    let begin = true;
    for (let i = 0; i < data.length; i++) {
      let value = data[i];
      if (value <= 0) continue;
      if (begin) {
        ctx.moveTo(i * this.xScale, value * this.yScale);
        begin = false;
      } else ctx.lineTo(i * this.xScale, value * this.yScale);
    }
    ctx.stroke();
    ctx.closePath();
  }

  updateLayerData(data) {
    this.ilm = data && data[SliceLayerTypes.Ilm] || [];
    this.rpe = data && data[SliceLayerTypes.Rpe] || [];
    this.signalReady();
  }

  updateSliceInfo(info) {
    if (this.sliceInfo !== info) this.sliceInfo = info;
    this.signalReady();
  }

  updateStretchSegmentation(doStretch) {
    this.stretchSegmentation = doStretch;
    this.signalReady();
  }
}